import { render, staticRenderFns } from "./DynamicInputsView.vue?vue&type=template&id=688143cc&"
import script from "./DynamicInputsView.vue?vue&type=script&lang=js&"
export * from "./DynamicInputsView.vue?vue&type=script&lang=js&"
import style0 from "./DynamicInputsView.vue?vue&type=style&index=0&id=688143cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports